import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "no-padding w-full" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["EnFilterButtonBase"], {
        modelValue: $setup.menuIsVisible,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.menuIsVisible) = $event)),
        "hide-apply-button": "",
        "reset-button-text": $setup.resetButtonTextComputed,
        "apply-filters": $setup.applyFilters,
        "on-reset-button-clicked": $setup.onResetButtonClicked,
        "display-string": $setup.displayString,
        "reset-filter": $setup.resetFilter,
        label: $props.label,
        id: $setup.returnFilterButtonId($props.id),
        "search-input-class": "bg-transparent"
    }, {
        label: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]),
        default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.fieldKeys, (fieldKey, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass([{ 'no-margin no-padding': $props.filterTypeSelectionVisible }, "flex"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode($setup["EnAutocomplete"], {
                            class: _normalizeClass({ 'col no-margin no-padding value-input': $props.filterTypeSelectionVisible }),
                            modelValue: $setup.currentOption[fieldKey].value,
                            "onUpdate:modelValue": ($event) => (($setup.currentOption[fieldKey].value) = $event),
                            hint: $setup.currentOption[fieldKey].label,
                            id: $setup.returnId(fieldKey),
                            autofocus: $setup.hasAutofocus(index, fieldKey),
                            "display-expression": item => $setup.getDisplayString(item, fieldKey),
                            "search-expression": $setup.currentOption[fieldKey].searchExpression,
                            "api-uri": $setup.currentOption[fieldKey].apiUrl,
                            "select-expression": [$setup.currentOption[fieldKey].property],
                            "item-value": $setup.currentOption[fieldKey].property,
                            "reload-on-focus-in": $setup.reloadOnFocusIn(index, fieldKey),
                            onInput: $setup.applyFiltersWithoutClosing,
                            "persistent-hint": "",
                            clearable: ""
                        }, null, 8 /* PROPS */, ["class", "modelValue", "onUpdate:modelValue", "hint", "id", "autofocus", "display-expression", "search-expression", "api-uri", "select-expression", "item-value", "reload-on-focus-in"]),
                        ($props.filterTypeSelectionVisible)
                            ? (_openBlock(), _createBlock($setup["EnFilterTypeSelectButton"], {
                                key: 0,
                                class: "pl-4 col",
                                id: $setup.returnTypeId(fieldKey),
                                modelValue: $setup.currentOption[fieldKey].type,
                                "onUpdate:modelValue": ($event) => (($setup.currentOption[fieldKey].type) = $event),
                                items: $setup.typeItemsString
                            }, null, 8 /* PROPS */, ["id", "modelValue", "onUpdate:modelValue", "items"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ], 2 /* CLASS */));
            }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "reset-button-text", "display-string", "label", "id"]));
}
